import React from 'react';
import css from './css.module.less';
import {
  Form,
  OriNumberInput,
  OriCheckbox,
  OriSelect,
} from 'src/components/Antd';
import Row from '@/src/components/Layouts/Row/Row';
import ItemWrapper from '@/src/components/Layouts/Item/Item';
import { isNumberOrString, isInteger } from 'src/tools/helper';
import SectionWrapper from '@/src/pages/SalesCannelVersion/Components/SectionWrapper';
import { get } from 'lodash';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const Option = OriSelect.Option;
const Item = Form.Item;

const _base = 'usageCondition';
const selectName = [_base, 'basedOn'];
const inputName = [_base, 'minimum'];
const checkboxName = [_base, 'flashSaleExcluded'];
// const selectName = [_base, 'basedOn'];

export enum EApplyTo {
  None = 'None',
  Value = 'Value',
  Count = 'Count',
}

const UsageCondition = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { currency, form, disabled } = props;
  return (
    <SectionWrapper
      title={`${getI18n('voucher.storeVoucherDetail.usageCondition')}`}>
      <Row
        elements={[
          {
            child: (
              <ItemWrapper
                title={getI18n('voucher.storeVoucherDetail.usageCondition')}>
                <Item name={selectName}>
                  <OriSelect size='large' disabled={disabled}>
                    <Option value={EApplyTo.None}>
                      {getI18n('general.status.none')}
                    </Option>
                    <Option value={EApplyTo.Value}>
                      {getI18n('voucher.storeVoucherDetail.orderAmount')}
                    </Option>
                    <Option value={EApplyTo.Count}>
                      {getI18n('voucher.storeVoucherDetail.quantityofitems')}
                    </Option>
                  </OriSelect>
                </Item>
              </ItemWrapper>
            ),
          },
          {
            child: <React.Fragment />,
          },
        ]}
      />

      <Row
        elements={[
          {
            child: (
              <Item
                shouldUpdate={(p, c) => {
                  const pV = get(p, selectName);
                  const cV = get(c, selectName);
                  return pV !== cV;
                }}>
                {({ getFieldValue }) => {
                  const select = getFieldValue(selectName);

                  // const display =
                  //   select && [EApplyTo.Value, EApplyTo.Count].includes(select);
                  if (select === EApplyTo.Value) {
                    const value = getFieldValue(inputName);

                    if (value) {
                      setTimeout(() => {
                        form.validateFields([inputName]);
                      });
                    }
                    return (
                      <React.Fragment>
                        <ItemWrapper
                          title={`${getI18n(
                            'voucher.storeVoucherDetail.minimumOrderAmount',
                          )}* (>=)`}>
                          <Item
                            name={inputName}
                            rules={[
                              {
                                validator: async (x, value) => {
                                  if (!isNumberOrString(value)) {
                                    return Promise.reject(
                                      new Error(
                                        getI18n(
                                          'general.pleasefillavalidvalue',
                                        ),
                                      ),
                                    );
                                  }
                                  if (value < 1) {
                                    return Promise.reject(
                                      new Error(
                                        getI18n(
                                          'voucher.storeVoucherDetail.valueshouldbenolessthan1',
                                        ),
                                      ),
                                    );
                                  }
                                },
                              },
                            ]}>
                            <OriNumberInput
                              size='large'
                              suffix={currency}
                              disabled={disabled}
                            />
                          </Item>
                        </ItemWrapper>
                        <Item
                          valuePropName={'checked'}
                          name={checkboxName}
                          className={css.checkbox}>
                          <OriCheckbox disabled={disabled}>
                            {getI18n(
                              'voucher.storeVoucherDetail.excludeflashsaleitems',
                            )}
                          </OriCheckbox>
                        </Item>
                      </React.Fragment>
                    );
                  }
                  if (select === EApplyTo.Count) {
                    const value = getFieldValue(inputName);

                    if (value) {
                      setTimeout(() => {
                        form.validateFields([inputName]);
                      });
                    }
                    return (
                      <React.Fragment>
                        <ItemWrapper
                          title={`${getI18n(
                            'voucher.storeVoucherDetail.minimumQuantityofItems',
                          )}* (>=)`}>
                          <Item
                            name={inputName}
                            rules={[
                              {
                                validator: async (x, value) => {
                                  if (!isInteger(value)) {
                                    return Promise.reject(
                                      new Error(
                                        getI18n(
                                          'general.pleasefillavalidvalue',
                                        ),
                                      ),
                                    );
                                  }
                                  if (value < 1) {
                                    return Promise.reject(
                                      new Error(
                                        getI18n(
                                          'voucher.storeVoucherDetail.valueshouldbenolessthan1',
                                        ),
                                      ),
                                    );
                                  }
                                },
                              },
                            ]}>
                            <OriNumberInput size='large' disabled={disabled} />
                          </Item>
                        </ItemWrapper>
                        <Item
                          valuePropName={'checked'}
                          name={checkboxName}
                          className={css.checkbox}>
                          <OriCheckbox>
                            {getI18n(
                              'voucher.storeVoucherDetail.excludeflashsaleitems',
                            )}
                          </OriCheckbox>
                        </Item>
                      </React.Fragment>
                    );
                  }
                }}
              </Item>
            ),
          },
          {
            child: <React.Fragment />,
          },
        ]}
      />
    </SectionWrapper>
  );
};
export default UsageCondition;
